<template>
    <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">

            <Form ref="ruleForm" @submit="addRule" :validation-schema="ruleSchema">
                <div class="row">

                    <div class="col-12 mb-3">
                        <h6 class="text-primary fw-semibold border-bottom pb-2">
                            <i class="ri-information-line"></i> Informations générales
                        </h6>
                    </div>

                    <!-- LIGNE 1 : Jeu de règles + Code + Libellé -->
                    <div class="col-md-4">
                        <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Jeu de règles <span class="text-danger">*</span>
                            </label>
                            <Field name="rule_set_id" v-slot="{ value, handleChange }">
                                <Multiselect :modelValue="value" @update:modelValue="handleChange"
                                    :options="ruleSetOptions" label="label" track-by="value" valueProp="value"
                                    placeholder="Sélectionner le jeu de règles" />
                            </Field>
                            <ErrorMessage name="rule_set_id" class="text-danger" />
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Code <span class="text-danger">*</span>
                            </label>
                            <Field name="code" type="text" class="form-control shadow-none fs-md-15 text-black"
                                placeholder="Entrer le code" />
                            <ErrorMessage name="code" class="text-danger" />
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Libellé <span class="text-danger">*</span>
                            </label>
                            <Field name="name" type="text" class="form-control shadow-none fs-md-15 text-black"
                                placeholder="Entrer le libellé" />
                            <ErrorMessage name="name" class="text-danger" />
                        </div>
                    </div>

                    <div class="col-12 mb-3 mt-3">
                        <h6 class="text-primary fw-semibold border-bottom pb-2">
                            <i class="ri-settings-3-line"></i> Configuration de la règle
                        </h6>
                    </div>

                    <!-- LIGNE 2 : Type entité + Sévérité + Type auto-flag -->
                    <div class="col-md-4">
                        <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Type d'entité ciblée <span class="text-danger">*</span>
                            </label>
                            <Field name="target_entity_type" v-slot="{ value, handleChange }">
                                <Multiselect :modelValue="value" @update:modelValue="handleChange"
                                    :options="targetOptions" label="label" track-by="value" valueProp="value"
                                    placeholder="Sélectionner le type d'entité" />
                            </Field>
                            <ErrorMessage name="target_entity_type" class="text-danger" />
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Sévérité <span class="text-danger">*</span>
                            </label>
                            <Field name="severity" v-slot="{ value, handleChange }">
                                <Multiselect :modelValue="value" @update:modelValue="handleChange"
                                    :options="severityOptions" label="label" track-by="value" valueProp="value"
                                    placeholder="Sélectionner la sévérité" />
                            </Field>
                            <ErrorMessage name="severity" class="text-danger" />
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Type d'auto-flag <span class="text-danger">*</span>
                            </label>
                            <Field name="auto_flag_type" v-slot="{ value, handleChange }">
                                <Multiselect :modelValue="value" @update:modelValue="handleChange"
                                    :options="autoFlagTypeOptions" label="label" track-by="value" valueProp="value"
                                    placeholder="Sélectionner le type d'alerte" />
                            </Field>
                            <ErrorMessage name="auto_flag_type" class="text-danger" />
                        </div>
                    </div>

                    <!-- LIGNE 3 : Description -->
                    <div class="col-md-12">
                        <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Description <span class="text-danger">*</span>
                            </label>
                            <Field name="description" as="textarea"
                                class="form-control shadow-none fs-md-15 text-black"
                                placeholder="Description..." rows="3" />
                            <ErrorMessage name="description" class="text-danger" />
                        </div>
                    </div>

                    <!-- LIGNE 4 : Expression de condition -->
                    <div class="col-md-12">
                        <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Expression de condition
                            </label>
                            <Field name="condition_expression" as="textarea"
                                class="form-control shadow-none fs-md-15 text-black" rows="4"
                                placeholder="Expression JSON ou condition métier..." />
                            <ErrorMessage name="condition_expression" class="text-danger" />
                            <small class="text-muted">Format JSON pour définir la logique de contrôle</small>
                        </div>
                    </div>

                    <div class="col-12 mb-3 mt-3">
                        <h6 class="text-primary fw-semibold border-bottom pb-2">
                            <i class="ri-calendar-line"></i> Période d'application
                        </h6>
                    </div>

                    <!-- LIGNE 5 : Date début + Date fin + Activer -->
                    <div class="col-md-4">
                        <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Date d'entrée en vigueur
                            </label>
                            <Field name="effective_from" type="date"
                                class="form-control shadow-none fs-md-15 text-black" />
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Date de fin d'application
                            </label>
                            <Field name="effective_to" type="date"
                                class="form-control shadow-none fs-md-15 text-black" />
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">Activer</label>
                            <Field name="is_enabled" type="checkbox" class="form-check-input"
                                :value="true" :unchecked-value="false" />
                        </div>
                    </div>

                    <div class="col-12 mb-3 mt-3">
                        <h6 class="text-primary fw-semibold border-bottom pb-2">
                            <i class="ri-time-line"></i> Moments d'exécution
                        </h6>
                    </div>

                    <!-- LIGNE 6 : Checkboxes moments d'exécution -->
                    <div class="col-md-12">
                        <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">Moments d'exécution</label>

                            <div class="form-check mb-2">
                                <Field name="run_on_creation" type="checkbox" class="form-check-input"
                                    id="runOnCreation" :value="true" :unchecked-value="false" />
                                <label class="form-check-label" for="runOnCreation">
                                    Exécuter à la création/soumission du dossier
                                </label>
                            </div>

                            <div class="form-check mb-2">
                                <Field name="run_on_update" type="checkbox" class="form-check-input"
                                    id="runOnUpdate" :value="true" :unchecked-value="false" />
                                <label class="form-check-label" for="runOnUpdate">
                                    Exécuter lors des mises à jour
                                </label>
                            </div>

                            <div class="form-check">
                                <Field name="run_on_pre_issuance" type="checkbox" class="form-check-input"
                                    id="runOnPreIssuance" :value="true" :unchecked-value="false" />
                                <label class="form-check-label" for="runOnPreIssuance">
                                    Exécuter obligatoirement avant émission (contrôle bloquant)
                                </label>
                            </div>
                        </div>
                    </div>

                    <!-- Boutons -->
                    <div class="col-md-12">
                        <div class="d-flex align-items-center">
                            <button
                                class="default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                                type="submit">
                                Ajouter règle de contrôle individuelle
                            </button>
                            <router-link to="/listeRule"
                                class="btn btn-danger transition border-0 lh-1 fw-medium">
                                <i class="flaticon-delete lh-1 me-1 position-relative top-2"></i>
                                <span class="position-relative"></span>Annuler
                            </router-link>
                        </div>
                    </div>

                </div>
            </Form>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, watch } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import { error, success } from '@/utils/utils';
import { useRouter } from "vue-router";
import ApiService from '@/services/ApiService';
import * as Yup from 'yup';
import axios from 'axios';
import Multiselect from '@vueform/multiselect'
import { Rule } from '@/models/Rule';

export default defineComponent({
    name: "AddRule",
    components: {
        Form,
        Field,
        ErrorMessage,
        Multiselect
    },
    setup: () => {
        const ruleSchema = Yup.object().shape({
            rule_set_id: Yup.string().required("Le type de jeu est obligatoire"),
            code: Yup.string().required("Le code est obligatoire"),
            name: Yup.string().required("Le libellé est obligatoire"),
            description: Yup.string().required("La description est obligatoire"),
            target_entity_type: Yup.string().required("L'entité ciblée est obligatoire"),
            condition_expression: Yup.string()
                .nullable()
                .test('valid-json', 'Le format JSON est invalide', (value) => {
                    if (!value) return true; 
                    try {
                    JSON.parse(value);
                    return true;
                    } catch {
                    return false;
                    }
                }),
            severity: Yup.string().required("La sévérité est obligatoire"),
            auto_flag_type: Yup.string().required("Le type d'auto-flag est obligatoire"),
            is_enabled: Yup.boolean(),
            run_on_creation: Yup.boolean(),
            run_on_update: Yup.boolean(),
            run_on_pre_issuance: Yup.boolean(),
            effective_from: Yup.date().nullable(),
            effective_to: Yup.date().nullable(),
        });

        const ruleForm = ref<Rule | null>(null);
        const ruleSetOptions = ref([]);
        const router = useRouter();


        const ruleCodeOptions = [
            { value: 'CHECK_WEIGHT_VOLUME', label: 'Vérification du poids et volume' },
            { value: 'FORBIDDEN_HS_CODE', label: 'Code HS interdit' },
            { value: 'BLACKLISTED_SHIPPER', label: 'Expéditeur sur liste noire' },
            { value: 'CHECK_VALUE_THRESHOLD', label: 'Seuil de valeur' },
            { value: 'CHECK_PORT_VALIDITY', label: 'Validité du port' },
        ];


        const severity = ref(null);
        const severityOptions = [
            { value: 'INFO', label: 'Information' },
            { value: 'WARNING', label: 'Avertissement' },
            { value: 'BLOCKING', label: 'Bloquant' },
            { value: 'HIGH_RISK', label: 'Risque élevé' }
        ];

        const target_entity_type = ref(null);
        const targetOptions = [
            { value: 'BESC_FILE', label: 'Dossier BESC' },
            { value: 'BILL_OF_LADING', label: 'Connaissement (BL)' },
            { value: 'BL_ITEM', label: 'Ligne de marchandise' },
            { value: 'PARTY', label: 'Partie (shipper, consignee...)' },
            { value: 'SUPPORTING_DOCUMENT', label: 'Document justificatif' }
        ];
        const autoFlagTypeOptions = [
            { value: 'RISK_ALERT', label: 'Alerte de risque' },
            { value: 'MANDATORY_REVIEW', label: 'Révision obligatoire' },
            { value: 'HARD_BLOCK', label: 'Blocage strict' },
            { value: 'DOCUMENT_MISSING', label: 'Document manquant' },
            { value: 'VALUE_MISMATCH', label: 'Incohérence de valeur' },
            { value: 'BLACKLIST_HIT', label: 'Correspondance liste noire' }
        ];


        const fetchRules = async () => {
            try {
                const response = await ApiService.get('/ruleset');
                const rulesData = response.data.data.data;
                console.log("ruleeeee", rulesData);
                ruleSetOptions.value = rulesData.map((rule) => ({
                    value: rule.id,
                    label: `${rule.code} - ${rule.name}`,
                }));
            } catch (error) {
                //
            }
        };
        const addRule = async (values, { resetForm }) => {
            const dataToSend = {
                ...values,
                is_enabled: values.is_enabled ?? false,
                run_on_creation: values.run_on_creation ?? false,
                run_on_update: values.run_on_update ?? false,
                run_on_pre_issuance: values.run_on_pre_issuance ?? false,
            };
            console.log("dodo", dataToSend);
            ApiService.post("/rule", dataToSend)
                .then(({ data }) => {
                    if (data.code == 201) {
                        success(data.message);
                        resetForm();
                        router.push({ name: "ListeRulePage" });
                    }
                }).catch(({ response }) => {
                    error(response.data.message);
                });
        };



        onMounted(() => {
            fetchRules();
        })
        return {
            addRule,
            ruleSchema,
            ruleForm,
            severity,
            severityOptions,
            target_entity_type,
            targetOptions,
            ruleSetOptions,
            autoFlagTypeOptions,
            ruleCodeOptions

        };
    },
});
</script>